import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateClaimSetupMeetingPromptedAtMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
  promptedAt: Types.Scalars['timestamptz']['input'];
}>;


export type UpdateClaimSetupMeetingPromptedAtMutation = { __typename?: 'mutation_root', update_authority_claims_by_pk?: { __typename?: 'authority_claims', id: any, setup_meeting_prompted_at?: any | null } | null };


export const UpdateClaimSetupMeetingPromptedAtDocument = gql`
    mutation UpdateClaimSetupMeetingPromptedAt($id: uuid!, $promptedAt: timestamptz!) {
  update_authority_claims_by_pk(
    pk_columns: {id: $id}
    _set: {setup_meeting_prompted_at: $promptedAt}
  ) {
    id
    setup_meeting_prompted_at
  }
}
    `;
export type UpdateClaimSetupMeetingPromptedAtMutationFn = Apollo.MutationFunction<UpdateClaimSetupMeetingPromptedAtMutation, UpdateClaimSetupMeetingPromptedAtMutationVariables>;

/**
 * __useUpdateClaimSetupMeetingPromptedAtMutation__
 *
 * To run a mutation, you first call `useUpdateClaimSetupMeetingPromptedAtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClaimSetupMeetingPromptedAtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClaimSetupMeetingPromptedAtMutation, { data, loading, error }] = useUpdateClaimSetupMeetingPromptedAtMutation({
 *   variables: {
 *      id: // value for 'id'
 *      promptedAt: // value for 'promptedAt'
 *   },
 * });
 */
export function useUpdateClaimSetupMeetingPromptedAtMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClaimSetupMeetingPromptedAtMutation, UpdateClaimSetupMeetingPromptedAtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClaimSetupMeetingPromptedAtMutation, UpdateClaimSetupMeetingPromptedAtMutationVariables>(UpdateClaimSetupMeetingPromptedAtDocument, options);
      }
export type UpdateClaimSetupMeetingPromptedAtMutationHookResult = ReturnType<typeof useUpdateClaimSetupMeetingPromptedAtMutation>;
export type UpdateClaimSetupMeetingPromptedAtMutationResult = Apollo.MutationResult<UpdateClaimSetupMeetingPromptedAtMutation>;
export type UpdateClaimSetupMeetingPromptedAtMutationOptions = Apollo.BaseMutationOptions<UpdateClaimSetupMeetingPromptedAtMutation, UpdateClaimSetupMeetingPromptedAtMutationVariables>;